module.exports = __webpack_public_path__ + "static/media/empty-file.1abffc73.svg";